(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  function initProductListScrollbars() {
    document.querySelectorAll('[data-testid="product-list"]').forEach((section) => {
      const scroller = section.querySelector('.resource-list__carousel slideshow-slides');
      const track = section.querySelector('[data-product-list-scrollbar]');
      const thumb = section.querySelector('[data-product-list-scrollbar-thumb]');

      if (!scroller || !track || !thumb || scroller.dataset.scrollbarBound) return;
      scroller.dataset.scrollbarBound = 'true';

      const update = () => {
        const { scrollWidth, clientWidth, scrollLeft } = scroller;
        const thumbRatio = Math.min(1, clientWidth / scrollWidth);
        const maxScroll = scrollWidth - clientWidth;
        const progress = maxScroll > 0 ? scrollLeft / maxScroll : 0;

        thumb.style.width = `${thumbRatio * 100}%`;
        thumb.style.left = `${progress * (1 - thumbRatio) * 100}%`;
        track.hidden = thumbRatio >= 1;
      };

      update();
      scroller.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(scroller);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductListScrollbars);
  } else {
    initProductListScrollbars();
  }

  document.addEventListener('shopify:section:load', initProductListScrollbars);

  } catch(e) { console.error(e); }
})();
})();
